module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-container",
    class: {
      /* 'kiwi-container-' + bufferType: true, */
      'kiwi-container--sidebar-open': _vm.sidebarOpen,
      'kiwi-container--no-sidebar': _vm.buffer && !_vm.buffer.isChannel(),
        'kiwi-container--mini': _vm.isHalfSize,
    }
  }, [(_vm.buffer) ? [_c('div', {
    staticClass: "kiwi-container-toggledraw-statebrowser",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleStateBrowser($event)
      }
    }
  }, [(!_vm.unreadMessages.count) ? _c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('div', {
    staticClass: "kiwi-container-toggledraw-statebrowser-messagecount",
    class: {
      'kiwi-container-toggledraw-statebrowser-messagecount--highlight': _vm.unreadMessages.highlight
    }
  }, [_vm._v(_vm._s(_vm.unreadMessages.count > 999 ? '999+' : _vm.unreadMessages.count))])]), _vm._v(" "), _c('container-header', {
    attrs: {
      "buffer": _vm.buffer
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'kiwi-container-toggledraw-sidebar': true,
      'kiwi-container-toggledraw-sidebar--disabled': !_vm.buffer.isChannel()
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleSidebar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.buffer.isServer()) ? [_c('server-view', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer
    }
  })] : [(_vm.buffer.isChannel()) ? _c('sidebar', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "users": _vm.users
    }
  }) : _vm._e(), _vm._v(" "), _c('message-list', {
    attrs: {
      "buffer": _vm.buffer,
      "users": _vm.users
    }
  })]] : [_vm._v("\n        " + _vm._s(_vm.$t('container_welcome')) + "\n        "), _c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleStateBrowser($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('container_statebrowser')))])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0334f446!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Container.vue
// module id = 474
// module chunks = 2